<template>
  <b-modal
    :visible="value"
    title="Editar Solicitante"
    size="lg"
    hide-footer
    centered
    @change="modalChangeEvent"
  >

    <SolicitanteEnEncargoForm
      :data="formData"
      :readonly="false"
      :errors="formErrors"
      @update="updateForm"
    />

    <div class="mt-4 text-right">
      <BfButton
        variant="secondary"
        class="mr-3"
        @click="modalChangeEvent(false)"
      >
        Cancelar
      </BfButton>
      <BfButton @click="saveFormData">
        Actualizar solicitante
      </BfButton>
    </div>
  </b-modal>
</template>

<script>
import isEqual from 'lodash.isequal';
import ApplicantForm from '@/components/FormGroups/ApplicantForm';
import SolicitanteEnEncargoForm from '@/components/FormGroups/SolicitanteEnEncargoForm';

export default {
  name: 'EditApplicantModal',

  props: {
    formData: {
      type: Object,
    },

    formErrors: {
      type: Object,
    },

    value: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      internalFormData: this.formData,
    };
  },

  methods: {
    updateForm({ key, value }) {
      this.internalFormData = {
        ...this.internalFormData,
        [key]: value,
      };
    },

    modalChangeEvent(visible) {
      this.$emit('input', visible);

      if (!visible) {
        this.internalFormData = this.formData;
      }
    },

    saveFormData() {
      this.$emit('update', this.internalFormData);
    },
  },

  watch: {
    formData(newData) {
      if (!isEqual(newData, this.internalFormData)) {
        this.internalFormData = newData;
      }
    },
  },

  components: {
    ApplicantForm,
    SolicitanteEnEncargoForm,
  },
};
</script>
